import ministryService from "../../../../services";
export default {
  namespaced: true,
  state: () => {
    return {
      holidays: {},
      holiday: {},
      hints: [],
      loading: false,
      working: false,
    };
  },
  getters: {
    holidays(state) {
      return state.holidays;
    },
    holiday(state) {
      return state.holiday;
    },
    hints(state) {
      return state.hints;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
  },
  mutations: {
    setHolidays(state, payload) {
      state.holidays = payload;
    },
    setHoliday(state, payload) {
      state.holiday = payload;
    },
    setHints(state, payload) {
      state.hints = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async fetchHolidays({ commit }) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchHolidays();
        commit("setHolidays", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchHoliday({ commit }, id) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchHoliday(id);
        commit("setHoliday", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async updateHoliday({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        await ministryService.updateHoliday(payload);
        await dispatch("fetchHolidays");
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async addHoliday({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        await ministryService.addHoliday(payload);
        await dispatch("fetchHolidays");
      } catch (err) {
    
      } finally {
        commit("setLoading", false);
      }
    },
    async deleteHoliday({ commit, dispatch }, id) {
      commit("setLoading", true);
      try {
        await ministryService.deleteHoliday(id);
        await dispatch("fetchHolidays");
      } catch (err) {
    
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
